export const FINISH_TUTORIAL_V2 = 'portal_compras/tutorial/FINISH_TUTORIAL_V2'
export const SHOW_REQUEST_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/SHOW_REQUEST_TUTORIAL_BANNER_V2'
export const SHOW_APPROVER_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/SHOW_APPROVER_TUTORIAL_BANNER'
export const CHECK_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/CHECK_TUTORIAL_BANNER_V2'
export const SHOW_NEWS_TUTORIAL_BANNER_V3 = 'portal_compras/tutorial/SHOW_NEWS_TUTORIAL_BANNER_V3'
export const SHOW_CANCEL_ORDER_TUTORIAL = 'portal_compras/tutorial/SHOW_CANCEL_ORDER_TUTORIAL'
